import { CreditCardVerificationDialog } from "@/components/billing/CreditCardVerificationDialog";

export function OnaVerificationDialog({
    open,
    onOpenChange,
    onVerificationSuccess,
}: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onVerificationSuccess: () => void;
}) {
    return (
        <CreditCardVerificationDialog
            open={open}
            onOpenChange={onOpenChange}
            onVerificationSuccess={onVerificationSuccess}
        />
    );
}
